import { HttpErrorResponse } from '@angular/common/http';

import { createSingleEntityStore, pipeState } from '@recruitee/ngrx';
import type { ReferralTemplate } from '@recruitee/referrals-types';

const { actions, selectors, reducer, namespace } = createSingleEntityStore<ReferralTemplate>()(
  'ReferralsTemplateItemCollection',
  {
    // eslint-disable-next-line max-lines-per-function
    customActions: adapter => ({
      fetch: (state, payload: number) => adapter.markAsPending(state),
      update: (state, payload: { id: number; data: Partial<ReferralTemplate> }) =>
        adapter.markAsPending(state),
      createOrUpdateCustomTemplate: (
        state,
        payload: {
          offerId: number;
          data: ReferralTemplate;
          isCustomAssigned: boolean;
        },
      ) => adapter.markAsPending(state),
      createOrUpdateCustomTemplateSuccess: (
        state,
        payload: { offerId: number; data: ReferralTemplate },
      ) =>
        pipeState(
          state,
          next => adapter.save(next, payload.data),
          next => adapter.markAsLoaded(next),
        ),
      createOrUpdateCustomTemplateFailed: (state, payload: HttpErrorResponse) =>
        adapter.setError(state, payload),
      setDefault: (state, payload: { templateId: number; isDefault: boolean }) =>
        adapter.markAsPending(state),
      setDefaultSuccess: (state, payload: { data: ReferralTemplate }) =>
        pipeState(
          state,
          next => adapter.save(next, payload.data),
          next => adapter.markAsLoaded(next),
        ),
      setDefaultFailed: (state, payload: HttpErrorResponse) => adapter.setError(state, payload),
      delete: (state, payload: number) => adapter.markAsPending(state),
      deleteSuccess: (state, payload: ReferralTemplate) =>
        pipeState(
          state,
          next => adapter.reset(),
          next => adapter.markAsLoaded(next),
        ),
      deleteFailed: (state, payload: HttpErrorResponse) => adapter.setError(state, payload),
      saveAsTemplate: (
        state,
        payload: {
          name: string;
          category: string;
          offerId: number;
        },
      ) => adapter.markAsPending(state),
      saveAsTemplateSuccess: (state, payload: { data: ReferralTemplate }) =>
        pipeState(
          state,
          next => adapter.save(next, payload.data),
          next => adapter.markAsLoaded(next),
        ),
      saveAsTemplateFailed: (state, payload: HttpErrorResponse) => adapter.setError(state, payload),
      create: (state, payload: Partial<ReferralTemplate>) => adapter.markAsPending(state),
      createSuccess: (state, payload: { data: ReferralTemplate }) =>
        pipeState(
          state,
          next => adapter.save(next, payload.data),
          next => adapter.markAsLoaded(next),
        ),
      createFailed: (state, payload: HttpErrorResponse) => adapter.setError(state, payload),
    }),
  },
);

const ReferralsTemplateItemActions = <
  Pick<
    typeof actions,
    | 'fetch'
    | 'fetchSuccess'
    | 'update'
    | 'updateSuccess'
    | 'updateFailed'
    | 'createOrUpdateCustomTemplate'
    | 'createOrUpdateCustomTemplateSuccess'
    | 'createOrUpdateCustomTemplateFailed'
    | 'setDefault'
    | 'setDefaultSuccess'
    | 'setDefaultFailed'
    | 'delete'
    | 'deleteSuccess'
    | 'deleteFailed'
    | 'saveAsTemplate'
    | 'saveAsTemplateSuccess'
    | 'saveAsTemplateFailed'
    | 'create'
    | 'createSuccess'
    | 'createFailed'
  >
>actions;

export {
  ReferralsTemplateItemActions,
  reducer as ReferralsTemplateItemReducer,
  selectors as ReferralsTemplateItemSelectors,
  namespace as ReferralsTemplateItemNamespace,
};
